var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/action/User-account_circle_24px@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/User-account_circle_24px",
    transform: "translate(-4.000000, -3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05343109,20.99 C9.12648812,20.99 11.4312809,20.99 12.9678094,20.99 L13,19.01 L7.05343109,19.01 C6.50114634,19.01 6.05343109,18.5622847 6.05343109,18.01 L6.05343109,5.98 C6.05343109,5.42771525 6.50114634,4.98 7.05343109,4.98 L12.9725784,4.98 L12.9725784,4.98 L12.9598043,3.01 C11.4250547,3.01 9.12293031,3.01 6.05343109,3.01 C4.95343109,3.01 4.05343109,3.89 4.05343109,4.99 L4.05343109,18.99 C4.05343109,20.1 4.95343109,20.99 6.05343109,20.99 Z M17.0534311,17.01 L22.0534311,12.01 L17.0534311,7.01 L17.0534311,10.76 L9.05343109,10.76 L9.05343109,13.26 L17.0534311,13.26 L17.0534311,17.01 Z",
    id: "icon/action/input_24px"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.3dae012484510312a114019f9a920a2a.svg";
export { ForwardRef as ReactComponent };